import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import type { ServiceCost } from '../api/types.js';

interface ServiceBreakdownChartProps {
  services: ServiceCost[];
}

function formatUsd(value: number): string {
  return `$${value.toFixed(2)}`;
}

export function ServiceBreakdownChart({ services }: ServiceBreakdownChartProps) {
  const data = services
    .filter((s) => s.cost > 0)
    .sort((a, b) => b.cost - a.cost);

  if (data.length === 0) {
    return (
      <div className="flex h-48 items-center justify-center" style={{ color: 'var(--color-text-3)' }}>
        No service cost breakdown available.
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={Math.max(200, data.length * 40)}>
      <BarChart data={data} layout="vertical" margin={{ top: 4, right: 4, left: 80, bottom: 4 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
        <XAxis type="number" tickFormatter={formatUsd} tick={{ fontSize: 12, fill: 'var(--color-text-3)' }} />
        <YAxis type="category" dataKey="service" tick={{ fontSize: 12, fill: 'var(--color-text-3)' }} width={76} />
        <Tooltip
          formatter={(value) => [formatUsd(Number(value ?? 0)), 'Cost']}
          contentStyle={{ backgroundColor: 'var(--color-surface-2)', border: '1px solid var(--color-border)', borderRadius: 6, color: 'var(--color-text)' }}
          labelStyle={{ color: 'var(--color-text-2)' }}
        />
        <Bar dataKey="cost" fill="var(--color-brand-light)" radius={[0, 4, 4, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
